<template>
  <div>
    <div class="d-flex flex-column" style="height: calc(100vh - 238px);">
      <div class="px-4 py-2">
        <div class="d-flex align-center">
          <div class="flex-fill pr-2">
            <div class="font-weight-bold" v-html="post.title"></div>
          </div>
          <div>
            <v-btn
              plain
              text
              icon
              @click="$emit('hidePost')"
            >
              <Icon
                :size="20"
                :color="'rgba(0,0,0,.54)'"
                icon="close"
              />
            </v-btn>
          </div>
        </div>
      </div>
      <div class="flex-fill overflow-auto pb-3" id="postContainer">
        <div class="post-detail body">
          <div class="d-flex images mx-4">
            <div
              v-for="(image, index) in post.images"
              :key="`post-image-${index}`"
              class="pr-1 pb-1 mt-2"
            >
              <v-img
                :lazy-src="image.url"
                :src="image.url"
                aspect-ratio="1"
                style="border-radius: 4px"
                width="158"
              ></v-img>
            </div>
          </div>
          <div
            class="px-4 py-2 text--secondary"
            v-html="post.description"
          ></div>
          <div class="actions px-4 py-2">
            <div
              v-if="post.actions.length"
              class="actions text-right"
            >
              <v-btn
                v-for="(action, index) in post.actions"
                :key="`action-${index}`"
                :color="action.color"
                elevation="0"
                class="px-3 action post-action"
                :style="`color: ${action.textcolor}`"
                @click="postAction(action, index)"
                :loading="action.type === 'ocular-category-attention' && link.loading && link.actionIndex === index"
                :disabled="action.type === 'ocular-category-attention' && link.loading && link.actionIndex === index"
              >
                {{ action.text }}
              </v-btn>
            </div>
          </div>
          <v-divider v-if="othersPosts.length" class="my-2 mx-0"></v-divider>
          <div
            v-if="othersPosts.length"
            class="mx-4 mt-2 text-center font-weight-bold"
          >
            <small>Otros productos</small>
          </div>
          <div
            v-for="(oldPost, index) in othersPosts"
            :key="`oldPost-${index}`"
            class="ml-1"
          >
            <v-sheet
              class="other-posts mx-3 mt-6 pointer"
              @click="show(oldPost)"
            >
              <div class="d-flex align-center">
                <div
                  v-if="oldPost.images.length"
                  class="image mr-3"
                >
                  <v-img
                    :lazy-src="oldPost.images[0].url"
                    :src="oldPost.images[0].url"
                    aspect-ratio="1"
                    style="border-radius: 4px"
                  ></v-img>
                </div>
                <div class="post-title">{{ oldPost.title }}</div>
              </div>
            </v-sheet>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import MainStreamingService from '@/services/MainStreamingService'

require('@/services/SessionLink')

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    room: {
      type: Object,
      default: null
    },
    post: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  watch: {
    'customer.id': function () {
      if (this.link.postAction) {
        this.postAction(this.link.postAction, this.link.actionIndex)
      }
    }
  },
  computed: {
    widget () {
      return this.$store.state.widget.data
    },
    othersPosts () {
      const postSelected = this.post
      const othersPosts = postSelected ? this.room.total_posts.filter((post) => post._id !== postSelected._id) : []
      return othersPosts.reverse()
    }
  }
})
export default class Index extends Vue {
  data () {
    return {
      link: {
        data: null,
        loading: false,
        actionIndex: 0,
        postAction: null
      },
    }
  }
  async postAction(action, index) {
    this.link.actionIndex = index
    this.link.postAction = action
    if (this.customer && this.customer.id) {
      this.saveAction(action)
      if (action.type === 'link') {
        window.open(action.action)
      } else if (action.type === 'js') {
        window.parent.postMessage(action.action, '*')
      } else if (action.type === 'ocular-category-attention') {
        const categoryCode = action.action
        this.generateSessionLink(categoryCode)
      }
    } else {
      this.$emit('setCustomer')
    }
  }

  async saveAction (action) {
    const data = {
      route: '/customer-actions',
      params: {
        post: this.post._id,
        session: this.room._id,
        customer: this.customer.id,
        action: {
          text: action.text,
          action: action.action,
          type: action.type
        }
      }
    }

    return MainStreamingService.post(data)
  }

  async generateSessionLink (categoryCode) {
    this.link.loading = true

    const params = {
      categoryCode
    }

    return this.$sessionLink.generateWidgetSessionLinkByCategory(params)
      .then((response) => {
        const res = response.data
        if (res.statusCode === 0 && res.data.link) {
          const link = res.data.link
          this.link.data = res.data
          window.open(link)
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        this.link.loading = false
      })
  }

  show(post) {
    document.getElementById('postContainer').scroll({ top:0 })
    const selected = {
      item: post,
      visible: true
    }
    this.$emit('showPost', selected)
  }

}
</script>

<style scoped>
  .actions {
    display: flex;
    gap: 5px;
    width: 100%;
    flex-wrap: wrap;
  }
  .post-action {
    margin-bottom: 5px;
    flex: 1;
    min-width: 104px !important;
  }

  .post-action:last-child {
    margin-bottom: 0px;
  }

  .other-posts p {
    line-height: 1.2;
    font-size: 14px;
  }
  .other-posts .image {
    width: 60px;
    height: 60px;
  }

  .other-posts .image .v-image {
    width: 100%;
    height: 100%;
    border: 2px solid #E6E6E6;
    border-radius: 50% !important;
    transition: all .2s;
  }
  .other-posts > div:hover h5 {
    text-decoration: underline;
  }

  .other-posts:hover .post-title {
    color: #166FE5;
  }

  .other-posts:hover .image .v-image {
    border: 2px solid #166FE5;
  }

  .images {
    padding-bottom: 5px;
    gap: 10px;
    overflow-x: auto;
    scrollbar-width: thin;
  }

  .post-title {
    font-size: 15px;
    transition: all .2s;
  }


  ::-webkit-scrollbar {
    height: 6px;
    background: #fff;
  }
  ::-webkit-scrollbar-thumb {
    background: #bebebe;
  }
</style>
